export default __webpack_public_path__ + "static/media/katif.6f269966.png";